import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
} from 'react';

import { AuthContext } from '@mint-lib/auth';
import { useService as useOldService } from '@mint-lib/hooks';

import { UserProfile } from '../getUserProfile/index.js';
import { ProfileService } from '../services/ProfileService.js';

export type AmbiguousUserProfile = null | UserProfile;

export type ProfileContextValue<IsAmbiguous extends boolean> = {
  profileData: IsAmbiguous extends true ? AmbiguousUserProfile : UserProfile;
  setProfileData: Dispatch<SetStateAction<AmbiguousUserProfile>>;
  profileService: ProfileService;
};

// @ts-ignore
export const ProfileContext = createContext<ProfileContextValue>();

/**
 * @deprecated
 */
export const ProfileProvider = ({
  children,
  value = null,
}: {
  children: ReactNode;
  value?: AmbiguousUserProfile;
}) => {
  const auth = useContext(AuthContext);
  const [profileService, version] = useOldService(ProfileService, auth);

  useEffect(() => {
    console.warn(
      'ProfileProvider from @mint-lib/profile-helpers has been deprecated, please use the new ProfileProvider from @mint-lib/routing-context instead.',
    );
  }, []);

  const contextValue = useMemo(
    () => ({
      profileData: profileService.getProfileData(),
      setProfileData: profileService.setProfileData.bind(profileService),
      profileService,
    }),
    [profileService, version],
  );

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};
